import { Button, Col, Dropdown, Form, Input, Modal, Row, Select, Spin, Switch, Tabs, Tag, Tooltip, message } from 'antd';
import React, { useEffect, useState } from 'react';
import TaskDetailBox from '../../components/PMS/TaskDetailBox';
import TaskLogBox from '../../components/PMS/TaskLogBox';
import ZenFormQuery from '../InputCreater/ZenFormQuery';
import { BulbOutlined, CalendarOutlined, CoffeeOutlined, CopyOutlined, DashboardOutlined, DeleteOutlined, DownloadOutlined, EditOutlined, GlobalOutlined, HeartFilled, LoadingOutlined, PlusOutlined, TableOutlined, TabletOutlined } from '@ant-design/icons';
import liracrypt from '../../components/Liracrypt/liracrypt';
import ApiErrorComp from '../../components/ApiErrorComp/ApiErrorComp';
import StAddNew from '../DSeries/StAddNew';
import TagBox from '../../components/PMS/TagBox';
import KanbanBoard from '../../components/PMS/KanbanBoard';
import StablePrime from '../../components/Tables/StablePrime';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import ImageController from '../InputCreater/ImageController';
import { useSelector } from 'react-redux';

const CreateTask = ({
    urlData
}) => {
    console.log(urlData);
    const { TabPane } = Tabs;
    const { search } = useLocation();
    const urlCode = useSelector(state => state.urlCode);
    const [taskListLoading, setTaskListLoading] = useState(false);
    const [taskFilter, setTaskFilter] = useState(false);
    const searchParams = queryString.parse(search);
    const [taskFormLoading, setTaskFormLoading] = useState(false);
    const [taskModal, setTaskModal] = useState({
        open: false,
        data: null,
        typ: ''
    });
    const [taskImgList, setTaskImgList] = useState([]);
    const [noOfBlocks, setNoOfBlocks] = useState('');
    const [taskListTyp, setTaskListTyp] = useState('kanban');
    const [tagModal, setTagModal] = useState({
        open: false,
        data: null,
        typ: ''
    });
    const [imaFiModal, setImafiModal] = useState({
        open: false,
        data: null,
        typ: ''
    });

    const items = [
        {
            key: '1',
            label: (
                <Button
                    style={{ marginRight: 10, color: '#1477ff' }}
                    type="link"
                    icon={
                        <EditOutlined />
                    }
                >{'Item 1'}</Button>
            ),
        },
        {
            key: '2',
            label: (
                <Button
                    style={{ marginRight: 10, color: '#1477ff' }}
                    type="link"
                    icon={
                        <EditOutlined />
                    }
                >{'Item 2'}</Button>
            ),
        },
        {
            key: '3',
            label: (
                <Button
                    style={{ marginRight: 10, color: '#1477ff' }}
                    type="link"
                    icon={
                        <EditOutlined />
                    }
                >{'Item 3'}</Button>
            ),
        },
    ];

    const [form] = Form.useForm();
    const [tagform] = Form.useForm();
    const [imafiForm] = Form.useForm();
    const [selectedTab, setSelectedTab] = useState("Info");
    const [tabList, setTabList] = useState(["Info", "Logs"]);
    const LocalDict = [];
    const [loading, setLoading] = useState(true);
    const [imafiFormLoading, setImafiFormLoading] = useState(false);
    const [imafiLoading, setImafiLoading] = useState(false);
    const [tagsloading, setTagsLoading] = useState(false);
    const [tagsData, setTagsData] = useState([]);
    const [modalElements, setModalElements] = useState();

    const getTags = () => {
        // setTagsLoading(true);
        liracrypt.get('/pms/tag', { ...searchParams, ...urlData, ...taskModal.data })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setTagsData(data.data);
                    setTagsLoading(false);
                } else {
                    message.error('Something went wrong');
                }
            }).catch(err => {
                ApiErrorComp();
                console.error(err);
            })
    }

    const deleteTag = (tagid) => {
        Modal.confirm({
            title: 'Are you sure you want to remove this tag?',
            onOk: () => {
                setTagsData(tagsData.filter(x => x._id !== tagid))
            },
            okButtonProps: { danger: true },
            okText: 'Yes',
            cancelText: 'No'
        })
    }

    const onFinish = (values) => {
        setTaskFormLoading(true);
        let data = { ...searchParams, ...urlData, ...values, ...taskModal.data, tagList: tagsData };
        liracrypt.post('/pms/newtask', data)
            .then(({ data }) => {
                if (data.isSuccess) {
                    message.success(data.message || 'Submitted Successfully');
                    setTaskModal({
                        open: false,
                        data: null,
                        typ: ''
                    });
                    setTaskFormLoading(false);
                    setTaskListTyp('');
                    setTimeout(() => {
                        setTaskListTyp('kanban');
                    }, 500);
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            })
            .catch(err => {
                console.error(err);
                ApiErrorComp();
            })
    }

    const saveImafi = (values) => {
        setImafiFormLoading(true);
        let data = { ...taskModal.data, ...searchParams, ...urlData, ...values };
        let formData = new FormData();
        formData.append("typ", "task");
        Object.keys(data).forEach(x => {
            if (data[x]) {
                formData.append(x, data[x]);
            }
        });
        liracrypt.uploadFile('/upload/multifilepsms', formData)
            .then(({ data }) => {
                if (data.isSuccess) {
                    message.success(data.message || 'Successfull');
                    setImafiFormLoading(false);
                } else {
                    setImafiFormLoading(false);
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                setImafiFormLoading(false);
                ApiErrorComp();
                console.log(err);
            })
    }


    const getTabsPannel = () => {
        if (selectedTab === 'Info') {
            return (
                <>
                    <Form
                        name={"createTask"}
                        labelWrap={true}
                        form={form}
                        labelCol={{ span: 8 }}
                        layout={"vertical"}
                        colon={false}
                        onFinish={onFinish}
                        size="large"
                    >
                        <Row>
                            <Col lg={12} md={10} sm={24} xs={24}>
                                <div className="task-box-container">
                                    <p className='pms-card-header'>TASK Form</p>
                                    <div className='scroller'>
                                        {
                                            loading ?
                                                <LoadingOutlined spin={true} style={{ fontSize: 30 }} /> :
                                                <ZenFormQuery form={form} LocalDict={LocalDict} modalElements={modalElements} extraData={{ ...searchParams, ...taskModal.data }} />
                                        }
                                    </div>
                                </div>
                                <div style={{ marginTop: 30 }}>

                                    <div className='tag_wrap' style={{ borderRadius: 10, marginRight: 10, border: '1px solid grey', padding: 5, background: '#04082b' }}>
                                        {
                                            tagsData.length ?
                                                tagsData.map((tag, index) => (
                                                    <div className='zen-preview-control-wrapper' style={{ display: 'inline-flex', color: '#ffffff', fontSize: 12, padding: '5px 10px 5px 10px', backgroundColor: tag.colr, alignItems: 'center', borderRadius: 10, margin: 10 }} key={index} color={tag.colr}>
                                                        <div style={{ marginRight: 10 }}>
                                                            {
                                                                tag.fav && (
                                                                    <HeartFilled color='red' size={20} />
                                                                )
                                                            }
                                                            {
                                                                tag.local && (
                                                                    <EditOutlined color='red' size={20} />
                                                                )
                                                            }
                                                            {
                                                                tag.global && (
                                                                    <GlobalOutlined color='red' size={20} />
                                                                )
                                                            }
                                                        </div>
                                                        <p style={{ marginBottom: 0 }}>{tag.label}</p>
                                                        <div className='control-edit-btns footer' style={{ display: 'flex', alignItems: 'center' }}>
                                                            <Tooltip title="Delete" color="red">
                                                                <Button
                                                                    style={{ marginLeft: 10 }}
                                                                    onClick={() => { deleteTag(tag._id) }}
                                                                    type="link"
                                                                    danger={true}
                                                                    icon={
                                                                        <DeleteOutlined style={{ fontSize: 30 }} />
                                                                    }
                                                                >{''}</Button>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                )) : <></>
                                        }
                                        <div
                                            onClick={() => {
                                                setTagModal({
                                                    open: true,
                                                    data: null,
                                                    typ: 'attach-tags'
                                                })
                                            }}
                                            style={{ cursor: 'pointer', display: 'inline-flex', color: '#ffffff', fontSize: 12, padding: '5px 10px 5px 10px', backgroundColor: '#1477ff', border: '3px solid #1477ff', borderRadius: 10, margin: 10 }}>
                                            <div style={{ marginRight: 10 }}>
                                                <PlusOutlined size={20} />
                                            </div>
                                            <p style={{ marginBottom: 0 }}>Attach Tag</p>
                                        </div>
                                    </div>
                                </div>

                            </Col>
                            <Col lg={12} md={11} sm={24} xs={24}>
                                <div className='task-box-container'>
                                    <TaskDetailBox api={'/pms/newtask'} params={{ ...taskModal.data, ...searchParams, dictName: 'PmsTaskBoxDetails' }} heading={'Task Details'} form={form} LocalDict={LocalDict} />
                                </div>
                                {/* <Row style={{ position: 'sticky', top: 0 }}>
                                    <Col lg={12} md={12} sm={24} xs={24}>
                                        <div className='task-box-container'>
                                            <TaskDetailBox api={'/miscellaneous/pageconfig'} params={{ ...taskModal.data, dictName: 'PmsTaskBoxDetails' }} heading={'Task Details'} form={form} LocalDict={LocalDict} />
                                        </div>
                                    </Col>
                                    <Col lg={12} md={12} sm={24} xs={24}>
                                        <div className='task-box-container'>
                                            <TaskLogBox api={'/textapi'} params={{ ...taskModal.data, dn: 'PmsApi004' }} heading={'Task Logs'} />
                                        </div>
                                    </Col>
                                    <Col style={{ padding: 10 }} lg={12} md={24} sm={24} xs={24}>
                                        <div style={{ borderRadius: 10, marginRight: 10, border: '1px solid grey', padding: 20, background: 'rgb(29, 29, 29)' }}>
                                            <Button onClick={() => {
                                                setImafiModal({
                                                    open: true,
                                                    typ: 'PMS_addImg',
                                                    data: null
                                                })
                                            }}>Add Image</Button>
                                            <Button onClick={() => {
                                                setImafiModal({
                                                    open: true,
                                                    typ: 'PMS_addFile',
                                                    data: null
                                                })
                                            }}>Add File</Button>
                                            <Button onClick={() => {
                                                setImafiModal({
                                                    open: true,
                                                    typ: 'PMS_pasteImg',
                                                    data: null
                                                })
                                            }}>Paste Image</Button>
                                            <p style={{ color: '#ffffff', textAlign: 'center', fontSize: 20 }}>ImaFi</p>
                                        </div>
                                    </Col>
                                    <Col style={{ padding: 10 }} lg={12} md={24} sm={24} xs={24}>
                                        <div className='action-btn-wrapper'>
                                            <Button
                                                style={{ color: '#1777ff', border: '1px solid #1777ff', borderRadius: 10, margin: 4 }}
                                                type='ghost'
                                                icon={
                                                    <EditOutlined />
                                                }>{''}</Button>
                                            <Button
                                                style={{ color: '#1777ff', border: '1px solid #1777ff', borderRadius: 10, margin: 4 }}
                                                type='ghost'
                                                icon={
                                                    <DeleteOutlined />
                                                }>{''}</Button>
                                            <Button
                                                style={{ color: '#1777ff', border: '1px solid #1777ff', borderRadius: 10, margin: 4 }}
                                                type='ghost'
                                                icon={
                                                    <CopyOutlined />
                                                }>{''}</Button>
                                            <Button
                                                style={{ color: '#1777ff', border: '1px solid #1777ff', borderRadius: 10, margin: 4 }}
                                                type='ghost'
                                                icon={
                                                    <DownloadOutlined />
                                                }>{''}</Button>
                                            <Button
                                                style={{ color: '#1777ff', border: '1px solid #1777ff', borderRadius: 10, margin: 4 }}
                                                type='ghost'
                                                icon={
                                                    <CalendarOutlined />
                                                }>{''}</Button>
                                            <Button
                                                style={{ color: '#1777ff', border: '1px solid #1777ff', borderRadius: 10, margin: 4 }}
                                                type='ghost'
                                                icon={
                                                    <BulbOutlined />
                                                }>{''}</Button>
                                            <Button
                                                style={{ color: '#1777ff', border: '1px solid #1777ff', borderRadius: 10, margin: 4 }}
                                                type='ghost'
                                                icon={
                                                    <CoffeeOutlined />
                                                }>{''}</Button>
                                            <Button
                                                style={{ color: '#1777ff', border: '1px solid #1777ff', borderRadius: 10, margin: 4 }}
                                                type='ghost'
                                                icon={
                                                    <DashboardOutlined />
                                                }>{''}</Button>
                                        </div>
                                    </Col>
                                </Row> */}
                            </Col>
                        </Row>
                        <Row gutter={24} justify="end">
                            <Col span={6}>
                                <Button onClick={cancelTaskModal} style={{ marginRight: 10 }} type="primary" danger={true} size={'large'}>Cancel</Button>
                                <Button loading={taskFormLoading} htmlType='submit' form='createTask' type='primary' size={'large'}>Submit</Button>
                            </Col>
                        </Row>
                    </Form>
                </>
            )
        };
        if (selectedTab === 'Improvement') {
            return (
                <p>Improvement</p>
            )
        };
        if (selectedTab === 'Logs') {
            return (
                <Row>
                    <Col span={8}>
                        <div className='task-box-container'>
                            <TaskLogBox api={'/pms/log'} params={{ ...taskModal.data, ...searchParams, dn: 'PmsApi004' }} heading={'Task Logs'} />
                        </div>
                    </Col>
                </Row>
            )
        };
        if (selectedTab === 'File Management') {
            return imafiLoading ? (
                <div className='Loading'>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} />} />
                </div>
            ) : (
                <div className="pms-file-management" style={{
                    padding: "10px",
                    maxHeight: "600px",
                    overflowY: "scroll",
                    overflowX: "hidden",
                }}>
                    <div className="ThemeForm" style={{ padding: 15 }}>
                        <Form
                            labelWrap={true}
                            name={"ImafiForm"}
                            form={imafiForm}
                            layout="horizontal"
                            colon={false}
                            onFinish={saveImafi}
                            size="large"
                        >
                            <Row justify={"center"}>
                                <Col span={12}>
                                    <Form.Item label={"Number of Blocks"} name="noOfBlock">
                                        <Select
                                            onChange={(val) => setNoOfBlocks(val)}
                                            options={Array.from({ length: 8 }).map((_, i) => {
                                                return { label: i + 1, value: i + 1 }
                                            })} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    Array.from({ length: noOfBlocks }).map((_, i) => (
                                        <Col span={6}>
                                            <div style={{ padding: 10, border: '1px solid #1477FF', margin: 5 }}>
                                                <Form.Item labelCol={8} name={`pms-text-${i}`} label="Label" required={true}>
                                                    <Input placeholder='Enter Label' type="text" />
                                                </Form.Item>
                                                <ImageController
                                                    pname={`noChange-${i}`}
                                                    labelCol={'0'} height={100} name={`pms-img-${i}`} label={"Img"} data={taskImgList[i] ? {
                                                        api: '/imagecontrol',
                                                        params: { ...searchParams, ...taskModal.data, _id: taskImgList[i].image },
                                                        hasImage: true
                                                    } : {}} form={imafiForm} errorMessage={"Please upload img"} required={true} disabled={false} />
                                            </div>
                                        </Col>
                                    ))
                                }
                            </Row>
                            <Row gutter={24} justify="center" style={{ marginTop: 10 }}>
                                <Col span={6}>
                                    <Button onClick={cancelTaskModal} style={{ marginRight: 10 }} type="primary" danger={true} size={'large'}>Cancel</Button>
                                    <Button loading={imafiFormLoading} htmlType='submit' form='ImafiForm' type='primary' size={'large'}>Submit</Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
                // <div style={{ borderRadius: 10, marginRight: 10, border: '1px solid grey', padding: 20, background: 'rgb(29, 29, 29)' }}>
                //     <Button onClick={() => {
                //         setImafiModal({
                //             open: true,
                //             typ: 'PMS_addImg',
                //             data: { ...taskModal.data }
                //         })
                //     }}>Add Image</Button>
                //     <Button onClick={() => {
                //         setImafiModal({
                //             open: true,
                //             typ: 'PMS_addFile',
                //             data: { ...taskModal.data }
                //         })
                //     }}>Add File</Button>
                //     <Button onClick={() => {
                //         setImafiModal({
                //             open: true,
                //             typ: 'PMS_pasteImg',
                //             data: { ...taskModal.data }
                //         })
                //     }}>Paste Image</Button>
                //     <p style={{ color: '#ffffff', textAlign: 'center', fontSize: 20 }}>ImaFi</p>
                // </div>
            )
        };
        if (selectedTab === 'In Damper Asy') {
            return (
                <p>In Damper Asy</p>
            )
        };
    };

    const hideTagModal = () => {
        setTagModal({
            open: false,
            typ: '',
            data: null
        })
    }

    const toggleTaskPopup = ({ open = false, data = null, typ = '' }) => {
        if (open) {
            setLoading(true);
        };
        if (data?.taskid !== 'new') {
            setTabList([...tabList, , "File Management"]);
        }
        setTaskModal({
            open,
            typ,
            data
        });
        if (!open) {
            setModalElements(null);
            imafiForm.resetFields();
            imafiForm.setFieldValue('noOfBlock', 1);
            setNoOfBlocks(1);
            setTagsData([]);
            setTabList(["Info", "Logs"]);
            setSelectedTab("Info");
        }
    }

    useEffect(() => {
        if (taskModal.open && selectedTab === 'Info') {
            setLoading(true);
            liracrypt.get('/pms/newtask', { ...searchParams, ...urlData, dictName: 'PmsTaskBoxBasic', ...taskModal.data })
                .then(({ data }) => {
                    setModalElements(data.config.modalElements);
                    // getTags();
                    setTagsData([...data.config.tagList]);
                    setLoading(false);
                }).catch(err => {
                    ApiErrorComp();
                    console.error(err);
                })
        }
    }, [taskModal.open, selectedTab]);

    useEffect(() => {
        if (taskModal.open && selectedTab === 'File Management') {
            setImafiLoading(true);
            // setLoading(true);
            liracrypt.get('/upload/multifilepsms', { ...searchParams, ...urlData, ...taskModal.data, typ: 'task' })
                .then(({ data }) => {
                    if (data.isSuccess) {
                        let totalBlock = data.data.length || 1;
                        imafiForm.setFieldValue('noOfBlock', totalBlock);
                        setNoOfBlocks(totalBlock);
                        setTaskImgList(data.data);
                        data.data.forEach((x, i) => {
                            imafiForm.setFieldValue(`pms-text-${i}`, x.label)
                        });
                        setImafiLoading(false);
                    } else {
                        setImafiLoading(false);
                        message.error(data.message || 'Something went wrong');
                    }
                    // setModalElements(data.config.modalElements);
                    // // getTags();
                    // setTagsData([...data.config.tagList]);
                    // setLoading(false);
                }).catch(err => {
                    setImafiLoading(false);
                    setNoOfBlocks(1);
                    imafiForm.setFieldValue('noOfBlock', 1);
                    ApiErrorComp();
                    console.error(err);
                })
        } else {
            imafiForm.resetFields();
            setImafiLoading(true);
            setTaskImgList([]);
            setNoOfBlocks(1);
        }
    }, [taskModal.open, selectedTab]);


    const cancelTaskModal = () => {
        Modal.confirm({
            title: "Are you sure you want to cancel task? Your changes won't be saved",
            onOk: () => toggleTaskPopup({}), //because of position of buttons, we will use cancel button as ok button.
            okText: 'Yes',
            cancelText: 'No',
            cancelButtonProps: { danger: true, type: 'primary' }
        })
    }


    return (
        <div className="pms pms-bg" style={{ padding: 10 }}>
            <div className='task-page-header'>
                <Tooltip color='blue' title="Create New Task" placement='top'>
                    <Button
                        style={{ marginLeft: 10 }}
                        ghost={true}
                        shape='round'
                        //    className='button-ghost'
                        type="primary"
                        icon={
                            <CalendarOutlined />
                        }
                        onClick={() => {
                            window.open(`/v02/${urlCode}/pms/task-calendar${search}`, '_blank')

                        }}>{'Open Calendar'}</Button>
                </Tooltip>
                <Tooltip color='blue' title="Create New Task" placement='top'>
                    <Button
                        style={{ marginLeft: 10 }}
                        ghost={true}
                        shape='round'
                        //    className='button-ghost'
                        type="primary"
                        icon={
                            <PlusOutlined />
                        }
                        onClick={() => {
                            toggleTaskPopup({
                                open: true,
                                data: {
                                    taskid: 'new'
                                },
                                typ: 'add-task'
                            });
                        }}>{'Create Task'}</Button>
                </Tooltip>
                <Tooltip color='blue' title="Kanban View" placement='top'>
                    <Button
                        style={{ marginLeft: 10 }}
                        shape='round'
                        ghost={true}
                        //    className='button-ghost'
                        type="primary"
                        icon={
                            <TabletOutlined />
                        }
                        onClick={() => {
                            setTaskListTyp('kanban');
                        }}>{'Kanban View'}</Button>
                </Tooltip>
                <Tooltip color='blue' title="Stable View" placement='top'>
                    <Button
                        ghost={true}
                        shape='round'
                        style={{ marginLeft: 10, marginRight: 10 }}
                        //    className='button-ghost'
                        type="primary"
                        icon={
                            <TableOutlined />
                        }
                        onClick={() => {
                            setTaskListTyp('stable');
                        }}>{'Stable View'}</Button>
                </Tooltip>
                {/* <Button onClick={() => {
                    setTaskListTyp(taskListTyp === 'kanban' ? 'stable' : 'kanban');
                }}>Toggle {taskListTyp === 'kanban' ? 'Stable View' : 'Kanban View'}</Button> */}
            </div>

            <div>
                <>
                    <StAddNew
                        urlMethod={"POST"}
                        formName="TaskQuery"
                        setSmodalTitle={title => { console.log(title) }}
                        initForm={tagform}
                        colSpan={12}
                        urlEndpoint={'/smodal/zenform'}
                        urlData={{ ...searchParams, ...urlData, dictName: 'TaskQuery' }}
                        onFormSubmit={(val) => {
                            setTaskListLoading(true);
                            setTaskFilter(val);
                            setTimeout(() => {
                                setTaskListLoading(false);
                            }, 500);
                        }}
                    />
                    <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex', marginBottom: 10 }}>
                        <Button loading={false} htmlType='submit' type="primary" form={'TaskQuery'}>Submit</Button>
                    </div>
                </>
                {
                    taskListLoading ?
                        <div className='Loading'>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 60 }} />} />
                        </div> :
                        <>
                            {
                                taskListTyp === 'kanban' ?
                                    <KanbanBoard
                                        params={{ ...searchParams, ...urlData, ...taskFilter }}
                                        onTaskClick={(data) => {
                                            toggleTaskPopup({
                                                open: true,
                                                data,
                                                typ: 'add-task'
                                            });
                                        }} /> :
                                    taskListTyp === 'stable' ?
                                        <StablePrime autoUpdate={true} zenTable={true} url="/report/reporttom" data={{ typ: 'projtask', subTyp: 'proj_001', ...searchParams, ...urlData, ...taskFilter }} identity="perfparam" /> : <></>
                            }
                        </>
                }
            </div>
            {
                taskModal.open && (
                    <Modal className='create-task-modal' centered={false} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} open={taskModal.open} title={taskModal.data.taskid === 'new' ? 'Add New Task' : 'Edit Task'} width={"90%"} onCancel={cancelTaskModal}>
                        <div
                            //    className="TabsPanel borderBox"
                            style={{
                                overflow: "hidden",
                                // backgroundColor: "#000000",
                                // borderRadius: "10px",
                                //  background: 'rgb(29, 29, 29)',
                                border: 0,
                                // boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                                // boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                            }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Tabs
                                    className='pms-tabs'
                                    style={{ minWidth: '92%' }}
                                    defaultActiveKey={selectedTab}
                                    type="card"
                                    tabPosition={"top"}
                                    tabBarStyle={{ border: 0 }}
                                    onChange={(activeKey) => setSelectedTab(activeKey)}
                                >
                                    {tabList.map((tab, i) => (
                                        <TabPane tab={tab} key={tab}></TabPane>
                                    ))}
                                </Tabs>
                                <Dropdown trigger={['click']} menu={{ items }} placement="bottomLeft" arrow>
                                    <Button
                                        style={{ marginRight: 10, color: '#1477ff' }}
                                        type="link"
                                        icon={
                                            <EditOutlined style={{ fontSize: 30 }} />
                                        }
                                    >{''}</Button>
                                </Dropdown>
                            </div>

                            <div>
                                {getTabsPannel()}
                            </div>
                        </div>
                    </Modal>
                )
            }

            {
                tagModal.open ?
                    <Modal width={'60%'} maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={tagModal.open} title={"Attach Tag"} onCancel={() => {
                        setTagModal({
                            open: false,
                            typ: '',
                            data: null
                        })
                    }}>
                        {
                            tagModal.typ === 'attach-tags' ?
                                <>
                                    <TagBox setTagList={(tags) => { setTagsData(tags); hideTagModal() }} tagList={tagsData} params={{ ...searchParams, ...taskModal.data }} onTagAttach={() => { hideTagModal(); getTags() }} />
                                    {/* <div style={{ width: '100%', textAlign: 'center' }}>
                                        <Button htmlType="button" type='primary'>Submit</Button>
                                    </div> */}
                                </> :
                                <>
                                    <StAddNew
                                        urlMethod={"POST"}
                                        formName="EditQueryForm"
                                        setSmodalTitle={title => { console.log(title) }}
                                        initForm={tagform}
                                        colSpan={24}
                                        urlEndpoint={'/smodal/zenform'}
                                        urlData={{ ...searchParams, dictName: 'Pms_tagForm' }}
                                        onFormSubmit={() => { }}
                                    />
                                    <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                                        <Button loading={false} htmlType='submit' type="primary" form={'EditQueryForm'}>Submit</Button>
                                    </div>
                                </>
                        }

                    </Modal>
                    : <></>
            }


            {
                imaFiModal.open && (
                    <Modal className='imafi-modal' width={'40%'} maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={imaFiModal.open} title={"ImaFi"} onCancel={() => {
                        setImafiModal({
                            open: false,
                            typ: '',
                            data: null
                        })
                    }}>
                        <>
                            <StAddNew
                                urlMethod={"GET"}
                                formName="ImafiForm"
                                setSmodalTitle={title => { console.log(title) }}
                                initForm={imafiForm}
                                colSpan={24}
                                urlEndpoint={'/smodal'}
                                urlData={{ ...searchParams, dictName: imaFiModal.typ }}
                                onFormSubmit={saveImafi}
                            />
                            <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                                <Button loading={imafiFormLoading} htmlType='submit' type="primary" form={'ImafiForm'}>Submit</Button>
                            </div>
                        </>

                    </Modal>

                )
            }

        </div >
    )
};

export default CreateTask;